// third-party
import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

// project imports
import snackbarReducer from './slices/snackbar';
import customerReducer from './slices/customer';
import contactReducer from './slices/contact';
import productReducer from './slices/product';
import chatReducer from './slices/chat';
import calendarReducer from './slices/calendar';
import mailReducer from './slices/mail';
import userReducer from './slices/user';
import dataReducer from './slices/data';
import kanbanReducer from './slices/kanban';
import menuReducer from './slices/menu';
import clientsReducer from './slices/clients';
import deploymentRequestsReducer from './slices/deployment-requests';
import deploymentGroupsReducer from './slices/deployment-groups';
import usersReducer from './slices/users';
import trialsReducer from './slices/trials';
import trialRequestsReducer from './slices/trial-requests';
import triggerWordsReducer from './slices/trigger-words';
import unitsReducer from './slices/units';
import analyticsReducer from './slices/analytics';
import logsReducer from './slices/logs';
import backdropReducer from './slices/backdrop';
import synchronisationLogs from './slices/synchronisationLogs';
import emailTemplatesReducer from './slices/email-templates';

// ==============================|| COMBINE REDUCER ||============================== //

const reducer = combineReducers({
    snackbar: snackbarReducer,
    data: persistReducer(
        {
            key: 'data',
            storage,
            keyPrefix: 'lln-robot-'
        },
        dataReducer
    ),
    kanban: kanbanReducer,
    customer: customerReducer,
    contact: contactReducer,
    product: productReducer,
    chat: chatReducer,
    calendar: calendarReducer,
    mail: mailReducer,
    user: userReducer,
    menu: menuReducer,
    clients: clientsReducer,
    deploymentRequests: deploymentRequestsReducer,
    deploymentGroups: deploymentGroupsReducer,
    users: usersReducer,
    trials: trialsReducer,
    trialRequests: trialRequestsReducer,
    triggerWords: triggerWordsReducer,
    units: unitsReducer,
    analytics: analyticsReducer,
    logs: logsReducer,
    backdrop: backdropReducer,
    synchronisationLog: synchronisationLogs,
    emailTemplates: emailTemplatesReducer
});

export default reducer;
